import { Stack } from '@fluentui/react';
import React, { useMemo } from 'react';
import { Document, Page } from 'react-pdf';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import 'react-pdf/dist/esm/Page/TextLayer.css';

const PdfViewer = (props) => {

    const {
        fileData = undefined,
        onLoadSuccess = ({ numPages }) => null,
        pageNumber = 1,
        scale = 1.95
    } = props;

    const fileUrl = useMemo(
        () => `data:application/pdf;base64,${fileData}`,
        [fileData]
    );



    return <Document
        error={<Stack padding={25}>Une erreur est survenue</Stack>}
        file={fileUrl}
        loading={null}
        onLoadError={error => console.error(error)}
        onLoadSuccess={onLoadSuccess}
        onSourceError={error => console.error(error)}
    >
        <Page
            loading={null}
            pageNumber={pageNumber}
            scale={scale}
        />
    </Document>;

};

export default PdfViewer;